<template>
  <div>
    <vx-card
        
        class="user-list-filters mb-8"
        collapse-action
      >
   <div class="vx-row">
    <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t("unified_Establishment") }}</label>
        <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.unified_Establishment" disabled />
    </div>
    <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("advertisement_Release_Date") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.advertisement_Release_Date" disabled/>
           </div>

    <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t("advertisement_License_Expiry_Date") }}</label>
        <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.advertisement_License_Expiry_Date" disabled />
    </div>
   </div>
   </vx-card>
    <vx-card
        
        class="user-list-filters mb-8"
        collapse-action
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t("ownershipDocumentNumber") }}</label>
            <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'"
              type="text"  class="mt-1 w-full" v-model="Model.ownershipDocumentNumber" disabled />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t("ownershipDocumentType") }}</label>
            <vs-input class="mt-1 w-full" :dir="$vs.rtl ? 'ltr' : 'ltr'"  v-model="Model.ownershipDocumentType" disabled/>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("propertyUsage") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.propertyUsage" disabled/>
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("saudiBuildingCodeCompliant") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.saudiBuildingCodeCompliant" disabled />
           </div>
          

          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("building_Number") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.building_Number" disabled />
           </div>
           <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("postalCode") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.postalCode" disabled />
           </div>

        </div>
  </vx-card>

  <vx-card class="user-list-filters mb-8"
  collapse-action>
        <div class="vx-row">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t("northernBoundaryType") }}</label>
            <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'"  type="text" class="mt-1 w-full"  v-model="Model.northernBoundaryType" disabled
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">{{ $t("northernBoundaryDescription") }}</label>
            <vs-input class="mt-1 w-full" :dir="$vs.rtl ? 'ltr' : 'ltr'"  v-model="Model.northernBoundaryDescription" disabled/>
          </div>
          
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("northernBoundaryLength") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.northernBoundaryLength" disabled />
           </div>
          
           <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("eastern_Boundary_Type") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.eastern_Boundary_Type" disabled />
           </div>
           <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("eastern_Boundary_Description") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.eastern_Boundary_Description" disabled />
           </div>
           <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
              <label class="text-sm opacity-75">{{ $t("eastern_Boundary_Length") }}</label>
              <vs-input :dir="$vs.rtl ? 'ltr' : 'ltr'" class="mt-1 w-full" v-model="Model.eastern_Boundary_Length" disabled />
           </div>
           
        </div>
  </vx-card>
  
  </div>
  </template>

  <script>
  import moduleQRCode from "@/store/QrCode/moduleQrCode";

  export default {
    data() {
      return {
        Model: {},
      };
    },

    created() {
      debugger;
      if (!moduleQRCode.isRegistered) {
        this.$store.registerModule("moduleQRCodeList", moduleQRCode);
        moduleQRCode.isRegistered = true;
      }
  debugger;

  const ID = this.$route.params.ID;
  console.log('this.$route.params.ID',this.$route.params.ID);
  console.log('ID',ID);
      debugger;
      if (ID != undefined && ID != 0) {
        debugger;
        this.$store.dispatch("moduleQRCodeList/GetItemById", ID).then((res) => {
          debugger;
          this.Model = res.data.data;
          this.$vs.loading.close();
        });
      } else if (ID == undefined) {
        ID == 0;
      }

    }
  };
  </script>

  <style>
  .user-list-filters {
  margin-top: 50px; 
  margin-bottom: 10px;
}

.vx-card label {
  font-weight: bold; 
  font-size: 1rem; 
}

.vs-input {
  font-weight: bold; 
}
  </style>
